/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
/* globals anime */
(function() {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
  );

  if ('serviceWorker' in navigator &&
    (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
      .then(function(registration) {
        // updatefound is fired if service-worker.js changes.
        registration.onupdatefound = function() {
          // updatefound is also fired the very first time the SW is installed,
          // and there's no need to prompt for a reload at that point.
          // So check here to see if the page is already controlled,
          // i.e. whether there's an existing service worker.
          if (navigator.serviceWorker.controller) {
            // The updatefound event implies that registration.installing is set:
            // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
            var installingWorker = registration.installing;

            installingWorker.onstatechange = function() {
              switch (installingWorker.state) {
                case 'installed':
                  // At this point, the old content will have been purged and the
                  // fresh content will have been added to the cache.
                  // It's the perfect time to display a "New content is
                  // available; please refresh." message in the page's interface.
                  break;

                case 'redundant':
                  throw new Error('The installing ' +
                    'service worker became redundant.');

                default:
                  // Ignore
              }
            };
          }
        };
      }).catch(function(e) {
        console.error('Error during service worker registration:', e);
      });
  }

  // Your custom JavaScript goes here

  var setDashoffset = function(el) {
    try {
      var l = el.getTotalLength();
      el.setAttribute('stroke-dasharray', l);
      return [l, 0];
    } catch (error) {
      return [1, 0];
    }
  };

  var joshAnime = anime({
    targets: '#josh path,#josh polygon',
    strokeDashoffset: {
      value: setDashoffset,
      duration: 700,
      easing: 'easeOutQuad'
    },
    opacity: [0, 1],
    transform: ['translate(0 128)', 'translate(0 0)'],
    delay: function(el, i) {
      return 750 + (i * 120);
    },
    duration: 1400
  });

  var kowarskyAnime = anime({
    targets: '#kowarsky path,#kowarsky polygon',
    strokeDashoffset: {
      value: setDashoffset,
      duration: 700,
      easing: 'easeOutQuad'
    },
    opacity: [0, 1],
    transform: ['translate(-640 0)', 'translate(0 0)'],
    delay: 2000,
    duration: 1600
  });

  var colorIndex = 0;
  var colors = ['#FFFDF9', '#02B1C9', '#6B90BC', '#4E4F56', '#000'];

  var colorAnimation = anime({
    targets: '#role',
    opacity: [0, 1],
    duration: 1000,
    delay: 3000,
    easing: 'linear',
    complete: function(anim) {
      rotateColors(colorIndex);
    }
  });

  

  function rotateColors(color) {
    var colorAnimation = anime({
      targets: '#developer-lines path',
      fill: colors[color],
      duration: 2700,
      delay: 3000,
      easing: 'linear',
      complete: function(anim) {
        // console.log(anim.completed);
        if (colorIndex >= colors.length) {
          colorIndex = 0;
        }
        rotateColors(colorIndex);
      }
    });
    colorIndex++;
  }

  document.getElementById('logo-container')
  .addEventListener('mouseenter', function() {
    if (kowarskyAnime.completed) {
      var joshFade = anime({
        targets: '#josh path,#josh polygon',
        opacity: [1, 0],
        easing: 'linear',
        transform: ['translate(0 0)', 'translate(0 40)'],
        duration: 100
      });
      var kowarskyFade = anime({
        targets: '#kowarsky path,#kowarsky polygon',
        easing: 'linear',
        opacity: [1, 0],
        transform: ['translate(0 0)', 'translate(0 40)'],
        duration: 100
      });
      joshFade.finished.then(function() {
        joshAnime.restart();
        kowarskyAnime.restart();
      });
    }
  });

  anime({
    targets: '#info',
    opacity: [0.0, 1.0],
    duration: 1500,
    easing: 'linear',
    delay: 2500
  });

  var c = document.getElementById('c');
  var ctx = c.getContext('2d');
  var cH;
  var cW;
  var bgColor = '#FFFDF9';
  var animations = [];
  // var circles = [];

  function extend(a, b) {
    for (var key in b) {
      if (b.hasOwnProperty(key)) {
        a[key] = b[key];
      }
    }
    return a;
  }

  var Circle = function(opts) {
    extend(this, opts);
  };

  Circle.prototype.draw = function() {
    ctx.globalAlpha = this.opacity || 1;
    ctx.beginPath();
    // ctx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false);
    var size = this.r * 2;
    ctx.rect(this.x - this.r, this.y - this.r, size, size);
    if (this.stroke) {
      ctx.strokeStyle = this.stroke.color;
      ctx.lineWidth = this.stroke.width;
      ctx.stroke();
    }
    if (this.fill) {
      ctx.fillStyle = this.fill;
      ctx.fill();
    }
    ctx.closePath();
    ctx.globalAlpha = 1;
  };

  var animate = anime({
    duration: Infinity,
    update: function() {
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, cW, cH);
      animations.forEach(function(anim) {
        anim.animatables.forEach(function(animatable) {
          animatable.target.draw();
        });
      });
    }
  });

  var colorPicker = (function() {
    var colors = ['#02B1C9', '#6B90BC', '#4E4F56'];
    var index = 0;

    function next() {
      index = index++ < colors.length - 1 ? index : 0;
      return colors[index];
    }

    function current() {
      return colors[index];
    }
    return {
      next: next,
      current: current
    };
  })();

  function removeAnimation(animation) {
    var index = animations.indexOf(animation);
    if (index > -1) {
      animations.splice(index, 1);
    }
  }

  function calcPageFillRadius(x, y) {
    var l = Math.max(x - 0, cW - x);
    var h = Math.max(y - 0, cH - y);
    return Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2));
  }

  function addClickListeners() {
    document.addEventListener('touchstart', handleEvent);
    document.addEventListener('mousedown', handleEvent);
  }

  function handleEvent(e) {
    if (e.touches) {
      // e.preventDefault();
      e = e.touches[0];
    }
    var currentColor = colorPicker.current();
    var nextColor = colorPicker.next();
    var targetR = calcPageFillRadius(e.pageX, e.pageY);
    var rippleSize = Math.min(200, (cW * 0.4));
    var minCoverDuration = 750;

    var pageFill = new Circle({
      x: e.pageX,
      y: e.pageY,
      r: 0,
      fill: nextColor
    });
    var fillAnimation = anime({
      targets: pageFill,
      r: targetR,
      duration: Math.max(targetR / 2, minCoverDuration),
      easing: 'easeOutQuart',
      complete: function() {
        bgColor = pageFill.fill;
        removeAnimation(fillAnimation);
      }
    });

    var ripple = new Circle({
      x: e.pageX,
      y: e.pageY,
      r: 0,
      fill: currentColor,
      stroke: {
        width: 3,
        color: currentColor
      },
      opacity: 1
    });
    var rippleAnimation = anime({
      targets: ripple,
      r: rippleSize,
      opacity: 0,
      easing: 'easeOutExpo',
      duration: 900,
      complete: removeAnimation
    });

    var particles = [];
    for (var i = 0; i < 32; i++) {
      var particle = new Circle({
        x: e.pageX,
        y: e.pageY,
        fill: currentColor,
        r: anime.random(24, 48)
      });
      particles.push(particle);
    }
    var particlesAnimation = anime({
      targets: particles,
      x: function(particle) {
        return particle.x + anime.random(rippleSize, -rippleSize);
      },
      y: function(particle) {
        return particle.y + anime.random(rippleSize * 1.15, -rippleSize * 1.15);
      },
      r: 0,
      easing: 'easeOutExpo',
      duration: anime.random(1000, 1300),
      complete: removeAnimation
    });
    animations.push(fillAnimation, rippleAnimation, particlesAnimation);
  }

  var resizeCanvas = function() {
    cW = window.innerWidth;
    cH = window.innerHeight;
    c.width = cW * devicePixelRatio;
    c.height = cH * devicePixelRatio;
    ctx.scale(devicePixelRatio, devicePixelRatio);
  };

  (function init() {
    resizeCanvas();
    if (window.CP) {
      // CodePen's loop detection was causin' problems
      // and I have no idea why, so...
      window.CP.PenTimer.MAX_TIME_IN_LOOP_WO_EXIT = 6000;
    }
    window.addEventListener('resize', resizeCanvas);
    addClickListeners();
    if (Boolean(window.location.pathname.match(/fullcpgrid/))) {
      startFauxClicking();
    }
    handleInactiveUser();
  })();

  function handleInactiveUser() {
    var inactive = setTimeout(function() {
      fauxClick(cW / 2, cH / 2);
    }, 2000);

    function clearInactiveTimeout() {
      clearTimeout(inactive);
      document.removeEventListener('mousedown', clearInactiveTimeout);
      document.removeEventListener('touchstart', clearInactiveTimeout);
    }

    document.addEventListener('mousedown', clearInactiveTimeout);
    document.addEventListener('touchstart', clearInactiveTimeout);
  }

  function startFauxClicking() {
    setTimeout(function() {
      fauxClick(anime.random(cW * 0.2, cW * 0.8), anime.random(cH * 0.2, cH * 0.8));
      startFauxClicking();
    }, anime.random(200, 900));
  }

  function fauxClick(x, y) {
    var fauxClick = new Event('mousedown');
    fauxClick.pageX = x;
    fauxClick.pageY = y;
    document.dispatchEvent(fauxClick);
  }
})();

function openModal(el) {
  // console.log(el);
  document.getElementById('modal').style.display = 'block';
  document.getElementById('modal').style.opacity = '1';

  document.getElementById(el + '-info').style.display = 'block';
}

function closeModal() {
  document.getElementById('modal').style.display = 'none';
  document.getElementById('modal').style.opacity = '0';
  var panels = document.getElementsByClassName('info-panel');
  for (var key in panels) {
    if (panels.hasOwnProperty(key)) {
      var element = panels[key];
      element.style.display = 'none';
    }
  }
}

// document.getElementById('modal').addEventListener('mousedown', function() {
//   console.log(this);
//   closeModal();
// });
